<template>
    <div>
        <span class="icon_timeline" :style="{ 'background-color': getAccessWay(item.access_way_id).color }" v-if="item.member_id">
            {{ getMember(item.member_id).name_initials }}
        </span>
        <span class="icon_timeline" style="background-color: #8338b1" v-else>
            PML
        </span>
        <h3 class="title_history" v-if="item.member_id">
            {{ getMember(item.member_id).full_name }}
            <span class="label label-sm pull-right m-t-5" :style="{ 'background-color': getAccessWay(item.access_way_id).color }"> {{ getAccessWay(item.access_way_id).name }} </span>
        </h3>
        <h3 class="title_history" v-else>
            Pump My Lead
            <span class="label label-sm pull-right m-t-5" style="background-color: #8338b1"> {{ $t('auto') }} </span>
        </h3>
        <small class="show m-b-15">
            <i class="fa fa-clock-o"> </i> {{ item.created_at | pmlDate('DD/MM/YYYY HH:mm:ss') }}
            <small class="text-muted m-l-5">({{ item.created_at | pmlHumanDate }})</small>
        </small>
        <div class="txt_history" :class="{ 'collapsed': collapsed }">
            <div v-html="content"></div>
            <div class="pointer collapse-button" :class="{ 'collapsed': collapsed }" @click="collapsed = !collapsed"></div>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import { findAccessWay, findMember } from 'utils/helpers/find-store'

    export default {
        name: 'FollowUpItem',
        props: [ 'item' ],
        data () {
            return {
                collapsed: true
            }
        },
        created () {
            bus.$on('collapseFollowUp', () => { this.collapsed = true })
            bus.$on('expandFollowUp', () => { this.collapsed = false })
        },
        destroyed () {
            bus.$off('collapseFollowUp')
            bus.$off('expandFollowUp')
        },
        computed: {
            content () {
                return this.$options.filters.pmlNl2br(this.item.content) || ''
            }
        },
        methods: {
            getAccessWay: (id) => {
                let accessWay = findAccessWay(id)

                if (typeof accessWay !== 'undefined')
                    return accessWay

                return {name: '', color: ''}
            },
            getMember: (id) => {
                let member = findMember(id)

                if (typeof member !== 'undefined')
                    return member

                return {name_initials: '', full_name: ''}
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/follow_ups/Item.vue